import { ROUTES } from 'src/constants/routes';

import { IBreadcrumb } from '../types/IBreadcrumb';

export const addDealBreadcrumbItems: IBreadcrumb[] = [
    {
        link: ROUTES.DEALS.INDEX,
        title: 'Deals'
    },
    {
        link: ROUTES.DEALS.ADD,
        title: 'Add deal'
    }
];

// step starts from index=1, so add 'PLACEHOLDER' to the beginning of the array
export const STEP_TEXT = ['PLACEHOLDER', 'Select vendors', 'Specify deals', 'Confirm and submit deals'];
